import convertToMercator from './convertToMercator'

const convertBoundsToMercatorBoundingBox = bounds => {
  const { _sw: sw, _ne: ne } = bounds
  try {
    const array = [[sw.lng, sw.lat], [ne.lng, ne.lat]]
    const lngOffset = (array[0][0] - array[1][0]) / 3
    const latOffset = (array[0][1] - array[1][1]) / 3

    const arrayOffset = [[sw.lng + lngOffset, sw.lat + latOffset],
                         [ne.lng - lngOffset, ne.lat - latOffset]]
    const mercatorArray = array.map(coordinate => convertToMercator(coordinate))
    
    return mercatorArray
  } catch(error) {
    console.warn(error)
    return [[0, 0], [0, 0]]
  }
}

export default convertBoundsToMercatorBoundingBox



// WEBPACK FOOTER //
// ./src/utility/convertBoundsToMercatorBoundingBox.js